import { useQuery } from '@tanstack/react-query';
import { getPlanOrders, getPlanOrder, GetPlanOrdersParams, GetPlanOrderParams } from '.';

export const useGetPlanOrders = (params: GetPlanOrdersParams) => {
  return useQuery({
    queryKey: ['getPlanOrders', params],
    queryFn: () => getPlanOrders(params)
  });
};

export const useGetPlanOrder = (params: GetPlanOrderParams) => {
  return useQuery({
    queryKey: ['getPlanOrder', params],
    queryFn: () => getPlanOrder(params),
    enabled: !!params.applicationId && !!params.orderId
  });
};

